import { FC, useMemo, useState } from 'react';
import ProfilingHubContent from '../../../pages/ProfilingHubPage/ProfilingHubContent';
import styles from './TeamProfilingTab.module.scss';

type AthleteLike = {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

interface Props {
  teamId: string;
  teamUsers: AthleteLike[];
}

/**
 * Tab "Profiling" del Dettaglio Team. Spec: l'utente seleziona
 * l'atleta dal roster del team e visualizza i 14 protocolli (P1-P14)
 * dell'atleta selezionato senza dover passare dal profilo individuale.
 *
 * Embed riusabile di ProfilingHubContent (stesso componente del Profilo
 * Atleta) per coerenza visiva e funzionale.
 */
const TeamProfilingTab: FC<Props> = ({ teamUsers }) => {
  const [selectedAthleteId, setSelectedAthleteId] = useState<string>('');

  const athletes = useMemo(
    () =>
      [...teamUsers]
        .filter((u): u is AthleteLike => !!u && typeof u === 'object' && !!u._id)
        .sort((a, b) => {
          const an = `${a.lastName ?? ''} ${a.firstName ?? ''}`.trim();
          const bn = `${b.lastName ?? ''} ${b.firstName ?? ''}`.trim();
          return an.localeCompare(bn);
        }),
    [teamUsers],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <label className={styles.label} htmlFor="team-profiling-athlete">
          Seleziona atleta
        </label>
        <select
          id="team-profiling-athlete"
          className={styles.select}
          value={selectedAthleteId}
          onChange={(e) => setSelectedAthleteId(e.target.value)}
        >
          <option value="">— Scegli atleta —</option>
          {athletes.map((a) => (
            <option key={a._id} value={a._id}>
              {a.lastName} {a.firstName}
            </option>
          ))}
        </select>
      </div>

      {selectedAthleteId ? (
        <div className={styles.body}>
          <ProfilingHubContent athleteId={selectedAthleteId} />
        </div>
      ) : (
        <div className={styles.empty}>
          Seleziona un atleta dal roster per visualizzare i suoi 14 protocolli di profiling (P1–P14).
        </div>
      )}
    </div>
  );
};

export default TeamProfilingTab;
